var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextCalendarButton = function SvgNextCalendarButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    stroke: "#4E6DF5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.378 22.043a1 1 0 0 1-1.414 0l-.274-.273a1 1 0 0 1 0-1.415l4.435-4.434-4.434-4.435a1 1 0 0 1 0-1.414l.273-.273a1 1 0 0 1 1.414 0L20.5 15.92l-6.122 6.122Z",
    fill: "#4E6DF5"
  })));
};
export default SvgNextCalendarButton;